var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextHFive = function SvgIconTextHFive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5.25a1 1 0 0 0-2 0V16.5a1 1 0 1 0 2 0v-4.625h7.75V16.5a1 1 0 1 0 2 0V5.25a1 1 0 1 0-2 0v4.625H4.75zM18.731 9.125a1 1 0 0 0-.987.84l-.731 4.519a1 1 0 0 0 1.694.867 1.624 1.624 0 1 1 0 2.298 1 1 0 1 0-1.414 1.414 3.626 3.626 0 1 0 2-6.144l.29-1.794H22.5a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconTextHFive;